import React, { useEffect, useReducer, useState } from "react";
import { updateDriverProfile } from "../../actions/commonActions";
import { useParams, useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import ProfileForm from "./ProfileForm";
import { retrieveDriverProfile } from "../../actions/commonActions";

export default function () {
  const urlParams = useParams();
  const history = useHistory();

  const dispatch = useDispatch();

  const [initialState, setInitialState] = useState({});

  const [profileId, setProfileId] = useState(undefined);

  const { driverProfile } = useSelector((reduxState) => reduxState);

  useEffect(() => {
    let { id } = urlParams;
    setProfileId(id);
    retrieveDriverProfile(dispatch, id);
  }, []);

  useEffect(() => {
    if (
      driverProfile &&
      driverProfile.userAccount &&
      driverProfile.userAccount.person
    ) {
      const { referring_ev_charging_site_id } = driverProfile;

      const {
        mobile_phone_number = "",
        email_address = "",
        person: {
          title_code = "",
          first_name = "",
          last_name = "",
          date_of_birth = "",
          sex_code = "",
          personAddress: {
            address_type_code = "",
            address: {
              // address_id,
              city_id = "",
              country_id = "",
              state_id = "",
              street_line_1 = "",
              street_line_2 = "",
              zip_code = "",
            },
          },
        },
      } = driverProfile.userAccount;
      setInitialState({
        first_name,
        last_name,
        title_code,
        date_of_birth,
        sex_code,
        mobile_phone_number,
        email: email_address,
        // sexRef: {
        //   sex_code: "",
        //   name: "",
        // },
        referring_ev_charging_site_id,
        city_id,
        country_id,
        state_id,
        street_line_1,
        street_line_2,
        zip_code,
        address_type_code,
      });
    }
  }, [driverProfile]);

  const onSubmit = (dispatch, payload) => {
    const {
      person_address_id,
      person_id,
      address: { address_id },
    } = driverProfile.userAccount.person.personAddress;
    const data = driverProfile
    // /Add values which are not editable in form and are not part of payload
    payload = {
      ...payload,
      user_account_id: data.user_account_id,
      driver_id: profileId,
      userAccount: {
        ...payload.userAccount,
        user_account_id: data.user_account_id,
        person_id: data.userAccount.person_id,
        person: {
          ...payload.userAccount.person,
          person_id: data.userAccount.person.person_id,
          personAddress: {
            ...payload.userAccount.person.personAddress,
            address: {
              ...payload.userAccount.person.personAddress.address,
              address_id,
            },
            person_address_id,
            person_id,
            address_id,
          },
        },
      },
    };
    // If country id is not present, assign empty object to personAddress key
    if (
      !(
        payload.userAccount.person.personAddress &&
        payload.userAccount.person.personAddress.address &&
        payload.userAccount.person.personAddress.address.country_id
      )
    ) {
      payload.userAccount.person.personAddress = {};
    }
    updateDriverProfile(dispatch, profileId, payload, () => {
      history.push(`/profile/${profileId}`);
    });
  };

  return (
    <ProfileForm
      initialState={initialState}
      onSubmit={onSubmit}
      isEditProfile={true}
    />
  );
}
